import { styled } from '@linaria/react';
import { layout, semantic, size, space, textStyle } from '../../theme/tokens';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
  padding: ${space['space-1600']} ${space['space-600']} ${space['space-1000']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    gap: ${space['space-800']};
    padding: ${space['space-2400']} ${space['space-1400']} ${space['space-1000']};
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-family: ${textStyle.title.md.fontFamily};
  font-size: ${textStyle.title.md.fontSize};
  font-weight: ${textStyle.title.md.fontWeight};
  line-height: ${textStyle.title.md.lineHeight};
  letter-spacing: ${textStyle.title.md.letterSpacing};
  color: ${semantic.text.primary};
`;

export const Footer = styled.div`
  padding: ${space['space-400']} ${space['space-600']};
  background: ${semantic.bg.canvas};
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-600']} ${space['space-400']};
  }
`;
